const TXT_BASE_URL = process.env.REACT_APP_SSO_TXTAPP_BASE_URL;

export const createAccountUrl = `${TXT_BASE_URL}/create-account`;
export const txtTermsUrl = `${TXT_BASE_URL}/terms-conditions`;
export const recoveryForgotPasswordUrl = `${TXT_BASE_URL}/forgot-password`;
export const recoveryForgotEmailUrl = `${TXT_BASE_URL}/forgot-username`;
export const accountRecoveryUrl = `${TXT_BASE_URL}/account-recovery`;

// External URLs
export const learnMoreUrl = 'https://www.texas.gov/texas-by-texas/';
export const learnMoreUrlEs ='https://www.texas.gov/es/texas-por-texas/';
export const texasGovHelpDeskUrl = 'https://www.texas.gov/help-support/';
export const texasGovHelpDeskUrlEs = 'https://www.texas.gov/es/servicio-de-asistencia/';
export const stateOfTexasUrl = 'https://texas.gov/';
